// useApiStatus — SWR hook polling GET /healthz (T634).
//
// /healthz is unauthenticated and returns plain-text "ok", not JSON — the
// shared `fetcher` still works because `apiRequest`'s `safeJSON` swallows
// the parse failure and resolves to `null` rather than throwing. A thrown
// `ApiError` (network failure, non-2xx) is what flips this to "offline".

import useSWR from 'swr';
import { fetcher } from './api';

const HEALTHZ_URL = '/healthz';

export function useApiStatus() {
  const { error, isLoading } = useSWR(HEALTHZ_URL, fetcher, {
    refreshInterval: 15_000,
    revalidateOnFocus: false,
  });
  return {
    online: !isLoading && !error,
    loading: isLoading,
  };
}
